import BorderGradient from "components/shared/BorderGradient/BorderGradient";
import { FiPlus } from 'react-icons/fi';
import * as Dialog from '@radix-ui/react-dialog';
import { useEffect, useState } from "react";
import { DiscountCode } from "./Discount";

interface DiscountFormData {
    code: string;
    discountType: string;
    description: string;
    discountValue: string;
    maximumRedemptions: number;
    maximumRedemptionsPerUser: number;
    startDate: string;
    endDate: string;
    applicablePlan: string;
}

const DiscountFormModal = ({ isOpen, mode, discountCodes, editedDiscountId, setDiscountCodes, onClose, setMode }:
    {
        isOpen: boolean;
        discountCodes: DiscountCode[];
        editedDiscountId: string | null;
        mode: string;
        setMode: React.Dispatch<React.SetStateAction<string>>;
        setDiscountCodes: React.Dispatch<React.SetStateAction<DiscountCode[]>>;
        onClose: () => void;
    }) => {
    const [formData, setFormData] = useState<DiscountFormData>({
        code: "",
        discountType: "",
        description: "",
        discountValue: "",
        maximumRedemptions: 0,
        maximumRedemptionsPerUser: 0,
        startDate: new Date().toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
        applicablePlan: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev: DiscountFormData) => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (mode === "add") {

            const newRecord: DiscountCode = {
                id: Math.random().toString(36).substring(2, 9),
                code: formData.code,
                description: formData.description,
                type: formData.discountType as '%' | '$', // type assertion
                value: formData.discountValue,
                maxRedemptions: formData.maximumRedemptions,
                used: formData.maximumRedemptionsPerUser, // if this is intentional
            };

            setDiscountCodes((prev: DiscountCode[]) => [...prev, newRecord]);
             // optional: close modal after save
        } else {
           
            setDiscountCodes((prev) =>
                prev.map((i) =>
                    i.id === editedDiscountId
                        ? {
                              ...i,
                              code: formData.code,
                              description: formData.description,
                              type: formData.discountType as '%' | '$',
                              value: formData.discountValue,
                              maxRedemptions: formData.maximumRedemptions,
                              used: formData.maximumRedemptionsPerUser,
                          }
                        : i
                )
            );
            
            setMode("add"); 
        }
        onClose();
    };

    useEffect(() => {
        if(mode === "edit"){

            const discountToEdit = discountCodes.find((i) => i.id === editedDiscountId);
            if(!discountToEdit) return;
            setFormData({
                code: discountToEdit?.code,
                discountType: discountToEdit?.type,
                description: discountToEdit?.description,
                discountValue: discountToEdit?.value,
                maximumRedemptions: 0,
                maximumRedemptionsPerUser: 0,
                startDate: new Date().toISOString().split("T")[0],
                endDate: new Date().toISOString().split("T")[0],
                applicablePlan: "",
            });
            // console.log("discountToEdit ===>", discountToEdit);
            console.log("discountToEdit ===>", discountToEdit);
        }
    },[isOpen]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
                <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[70vh]">
                    <BorderGradient className='rounded-lg flex flex-col h-full w-full'>
                        <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full">
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-4 text-gray-400 hover:text-white"
                            >
                                <FiPlus size={24} className="rotate-45" />
                            </button>

                            <h2 className="text-xl font-semibold mb-6 text-white">{mode === "add"? "Add"
                            :"Edit"} Discount</h2>


                            <form className="space-y-4" onSubmit={handleSubmit}>

                                <div className='bg-[#232323] rounded-lg p-2 mt-5'>
                                    <h3>Discount details</h3>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Code</label>
                                        <input
                                            type="text"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter discount code"
                                            name="code"
                                            value={formData.code}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Discount Type</label>
                                        <select
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            name="discountType"
                                            value={formData.discountType}
                                            onChange={handleChange}
                                        >
                                            <option value="%">Percentage (%)</option>
                                            <option value="$">Fixed Amount ($)</option>
                                        </select>
                                    </div>
                                </div>


                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Description</label>
                                        <input type="text" name="description" id="description" className="w-full bg-[#2A2A2A]  border border-black/[0.8] rounded-md px-3 py-2"
                                            value={formData.description}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Discount Value</label>
                                        <input
                                            type="text"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter value"
                                            name="discountValue"
                                            value={formData.discountValue}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className='bg-[#232323] rounded-lg p-2 my-10'>
                                    <h3>Usage Limit</h3>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Maximum redemptions</label>
                                        <input
                                            type="text"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter value"
                                            name="maximumRedemptions"
                                            value={formData.maximumRedemptions}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Maximum redemptions Per User</label>
                                        <input
                                            type="text"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter value"
                                            name="maximumRedemptionsPerUser"
                                            value={formData.maximumRedemptionsPerUser}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>


                                <div className='bg-[#232323] rounded-lg p-2 '>
                                    <h3>Validity Period</h3>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">Start Date</label>
                                        <input
                                            type="date"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter value"
                                            name="startDate"
                                            value={formData.startDate}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm text-gray-400 mb-1">End Dater</label>
                                        <input
                                            type="date"
                                            className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                            placeholder="Enter value"
                                            name="endDate"
                                            value={formData.endDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>


                                <div className='bg-[#232323] rounded-lg p-2 my-10'>
                                    <h3>Discount Details</h3>
                                </div>

                                <div>
                                    <label htmlFor="applicablePlan" className="block text-sm text-gray-400 mb-1">Applicable plan</label>
                                    <select name="applicablePlan" id="applicablePlan" className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        value={formData.applicablePlan}
                                        onChange={handleChange}
                                    >
                                        <option value="planOne">Plan One</option>
                                        <option value="planTwo">Plan Two</option>
                                    </select>
                                </div>


                                <div className="flex justify-end pt-4">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                         className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[140px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="flex items-cente justify-center gap-2 px-4 py-2 w-[140px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                    >
                                        Save Discount
                                    </button>
                                </div>
                            </form>
                        </div>

                    </BorderGradient>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>

    );
};

export default DiscountFormModal;